module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "720px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("AI Analysis · " + _vm._s(_vm.label))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 pt-4"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "hide-details": "",
      "placeholder": ("Short paragraph about " + _vm.label + " performance…")
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input', false)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": "",
      "loading": _vm.generating,
      "disabled": !_vm.posts || !_vm.posts.length
    },
    on: {
      "click": _vm.generate
    }
  }, [_c('i', {
    staticClass: "fas fa-magic mr-2"
  }), _vm._v(" Generate with AI\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-373c2372"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/TableAiAnalysisModal.vue
// module id = 2078
// module chunks = 0